import { useDispatch, useSelector } from 'react-redux';
import { Data } from '../signup-data/DATA';
import { useSignupData } from '../signup-data/useSignupData';
import { updateTypeaheadInputValue, updateTypeaheadSelectedValue, updateTypeaheadTrackedUserInput } from '../store/typeahead/action-creators';
import { getTypeaheadInputValue, getTypeaheadSelectedValue, getTypeaheadTrackedUserInput } from '../store/typeahead/selectors';
const getJobRoleSelectedValue = getTypeaheadSelectedValue(Data.JobRole);
const getJobRoleTrackedUserInput = getTypeaheadTrackedUserInput(Data.JobRole);
const getJobRoleInputValue = getTypeaheadInputValue(Data.JobRole);
export const useJobRole = () => {
  const dispatch = useDispatch();
  const jobRoleSelectedValue = useSelector(getJobRoleSelectedValue);
  const jobRoleTrackedUserInput = useSelector(getJobRoleTrackedUserInput);
  const jobRoleInputValue = useSelector(getJobRoleInputValue);
  const {
    data: jobRoleSignupData,
    setData: setJobRoleSignupData
  } = useSignupData(Data.JobRole);

  const setInputValue = value => {
    dispatch(updateTypeaheadInputValue(value, Data.JobRole));
  };

  const setTrackedUserInput = inputValue => {
    dispatch(updateTypeaheadTrackedUserInput(inputValue, Data.JobRole));
    setJobRoleSignupData('');
    setInputValue(inputValue);
  };

  const setSelectedValue = jobRole => {
    dispatch(updateTypeaheadSelectedValue(jobRole.text, Data.JobRole));
    setInputValue(jobRole.text);
    setJobRoleSignupData(jobRole.id);
  };

  return {
    jobRoleTrackedUserInput,
    jobRoleSelectedValue,
    jobRoleInputValue,
    jobRoleSelected: jobRoleSignupData,
    setTrackedUserInput,
    setSelectedValue
  };
};